
import React from 'react';
import {connect} from  'react-redux';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import NumberFormat from '../NumberFormat';

const schema = yup.object().shape({
    monthlyExpenses: yup.number().positive().required('Please enter total of your monthly expenses'),
    // inflation: yup.number().required('Please enter inflation rate')
  });

class Step8 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    values = {
        currentMonthlyExpenseAfterTax: values.monthlyExpenses,
        // projectedInflationRate: values.inflation
    }
    this.props.upliftState(values,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
     
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                             <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>8.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(8) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={8} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="validationFormikmonthlyExpenses">
                                    <Form.Label className="required">Monthly Expenses</Form.Label>
                                    <NumberFormat
                                        value={values.monthlyExpenses} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'monthlyExpenses', e.floatValue);
                                                    setFieldTouched( 'monthlyExpenses',true);  }}
                                        error={ getIn(errors,'monthlyExpenses') }
                                        />
                                    </Form.Group>
                            <Form.Group as={Col} style={{"padding":"0px","margin":"0px"}} md="12" controlId="step8Continue">
                                <Col md={"12"} sm={"12"}>
                                    <Stats type='continue' step={8} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let monthlyExpenses = scenario.currentMonthlyExpenseAfterTax || 0;
        return {
            form,
            monthlyExpenses,
            isMarried:client.isMarried,
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
    )(Step8)